import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Keys } from '@holmescorp/common';
import { publish } from '@holmescorp/pub-sub';
import css from '../css/resource-parser.m.css';
import { includes } from 'lodash-es';
const factory = create({ theme }).properties();
export const RcsButton = factory(({ children, properties, middleware: { theme } }) => {
    const { key, path, flags = [] } = properties();
    const act = `site/rcs${path}`;
    const themeCss = theme.classes(css);
    const role = includes(flags, 'ariaRoleListitem') ? 'listitem button' : 'button';
    return v('div', {
        key,
        classes: [themeCss.rcslink],
        tabIndex: 0,
        role,
        onclick: (event) => {
            event.stopPropagation();
            publish(act);
        },
        onkeydown: (event) => {
            switch (event.key) {
                case Keys.Enter:
                case Keys.Space:
                case Keys.Spacebar:
                    event.preventDefault();
                    publish(act);
                    break;
            }
        }
    }, children());
});
